import styled from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';
var Table = styled(Box).withConfig({
  componentId: "lwvcfv-0"
})(["display:table;width:100%;border-collapse:collapse;border-spacing:0;position:relative;z-index:0;"]);
var Styled = {
  Table: Table
};
export { Styled };